import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "analytics--sprite",
  "use": "analytics--sprite-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"analytics--sprite\">\n<path d=\"M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM16 16H2V2H16V16Z\" />\n<path d=\"M6 9H4V14H6V9Z\" />\n<path d=\"M14 4H12V14H14V4Z\" />\n<path d=\"M10 11H8V14H10V11Z\" />\n<path d=\"M10 7H8V9H10V7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol